export const Environments = {
  // GENERAL
  TABLE_MAP_WIDGET_MAP_ID: process.env.NEXT_PUBLIC_TABLE_MAP_WIDGET_MAP_ID ?? 'NOT_DEFINED',
  GOOGLE_MAPS_LIBRARY_VERSION: process.env.NEXT_PUBLIC_GOOGLE_MAPS_LIBRARY_VERSION ?? 'NOT_DEFINED',
  // API KEYS 
  GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? 'NOT_DEFINED',
  // URLS
  PORTAL_API_URL: process.env.NEXT_PUBLIC_PORTAL_API_URL ?? "NOT_DEFINED",
  MAP_DATA_LAYER_API_URL: process.env.NEXT_PUBLIC_MAP_DATA_LAYER_API_URL ?? "NOT_DEFINED",
  ACTIVE_DEALER_LIST_API_URL: process.env.NEXT_PUBLIC_ACTIVE_DEALER_LIST_API_URL ?? "NOT_DEFINED",
  // Set to "/transactions" (legacy) or "/transactionsV2" (pipeline)
  TRANSACTIONS_ENDPOINT: process.env.NEXT_PUBLIC_TRANSACTIONS_ENDPOINT ?? "/transactionsV2",
};
